export default __webpack_public_path__ + "static/media/7-2.cd94589d.mp3";